import moment from 'moment';

import {
	read as momentFromIso,
	write as momentToIso,
} from 'ko-extender-view-moment-from-iso';

const DATE_FORMAT = 'DD.MM.YYYY';
const TIME_FORMAT = 'HH:mm';

export const readDate = iso => {
	const m = momentFromIso(iso);
	if (!m.isValid()) {
		return iso;
	}
	return m.format(DATE_FORMAT);
};

export const writeDate = lrd => {
	const m = moment(lrd, DATE_FORMAT, true);
	if (m.isValid()) {
		return momentToIso(m);
	}
	return lrd;
};

export const localRussianDateViewExtend = {
	view: {
		localRussianDate: {
			read: readDate,
			write: writeDate,
		},
	},
};

export const readTime = iso => {
	const m = momentFromIso(iso);
	if (!m.isValid()) {
		return iso;
	}
	return m.format(TIME_FORMAT);
};

export const writeTime = lrd => {
	const m = moment(lrd, TIME_FORMAT, true);
	if (m.isValid()) {
		return momentToIso(m);
	}
	return lrd;
};
export const localRussianTimeViewExtend = {
	view: {
		moscowRussianTime: {
			read: readTime,
			write: writeTime,
		},
	},
};
